import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Container, Form, Button, Card, Spinner } from "react-bootstrap";
import { api } from "./api";

const Login = () => {
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.search.includes("reason=session-expired")) {
      setErrorMessage("Your session expired. Please sign in again.");
    }
  }, [location.search]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/api/auth/login", { pin });
          // Store token
    localStorage.setItem("token", data.token);

    // Store user data as JSON string
    localStorage.setItem("user", JSON.stringify(data.user));

      navigate("/dashboard");
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Unable to sign in. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="p-4 shadow" style={{ width: "100%", maxWidth: "400px" }}>
        <h1 className="h3 text-center mb-3">Sign in</h1>
        <p className="text-muted text-center">Enter your staff PIN to continue.</p>
        {errorMessage && <Alert variant="danger" role="alert">{errorMessage}</Alert>}
        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Label></Form.Label>
            <Form.Control 
              type="password" 
              placeholder="Enter PIN" 
              value={pin} 
              onChange={(e) => setPin(e.target.value)} 
              inputMode="numeric"
              autoComplete="current-password"
              aria-label="Staff PIN"
              minLength={4}
              maxLength={12}
              required 
            />
          </Form.Group>
          <Button type="submit" className="w-100" disabled={submitting}>
            {submitting ? <><Spinner size="sm" className="me-2" />Signing in...</> : "Sign in"}
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default Login;
